// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#inv-copy-to {
  max-width: none;
  margin: 0px 0px -10px;
}
#inv-copy-to .k-grid {
  margin: 0px 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/cp/invoices/invoice-copyto-new/invoice-copyto-new.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EAEA,qBAAA;AAAD;AAEC;EACC,oBAAA;AAAF","sourcesContent":["#inv-copy-to {\n\tmax-width:none;\n\t//width: 100vw;\n\tmargin: 0px 0px -10px;\n\n\t.k-grid {\n\t\tmargin: 0px 0px 10px;\n\t}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
